<template>
  <nav class="l-nav">
    <AppIcon name="logo" classes="c-icon--xl" />
    <slot />
  </nav>
</template>

<script>
import AppIcon from '../AppIcon';

export default {
  name: 'AppNav',
  components: {
    AppIcon,
  },
};
</script>
